export const ROULETTE_RED_NUMBERS = new Set([
  "1",
  "3",
  "5",
  "7",
  "9",
  "12",
  "14",
  "16",
  "18",
  "19",
  "21",
  "23",
  "25",
  "27",
  "30",
  "32",
  "34",
  "36",
]);

export const ROULETTE_NUMBERS = Array.from(
  { length: 36 },
  (_, index) => String(index + 1)
);

export const ROULETTE_DOZENS = [
  { type: "dozen", selection: "1st_12", label: "1ST 12" },
  { type: "dozen", selection: "2nd_12", label: "2ND 12" },
  { type: "dozen", selection: "3rd_12", label: "3RD 12" },
];

export const ROULETTE_COLUMNS = [
  { type: "column", selection: "column_1", label: "COLUMN 1" },
  { type: "column", selection: "column_2", label: "COLUMN 2" },
  { type: "column", selection: "column_3", label: "COLUMN 3" },
];

export const ROULETTE_COLOURS = [
  { type: "colour", selection: "red", label: "RED" },
  { type: "colour", selection: "black", label: "BLACK" },
];

export function rouletteRegionKey(type, selection) {
  return `${String(type)}:${String(selection)}`;
}

export function getStraightColour(number) {
  const value = String(number);

  if (value === "0" || value === "00") {
    return "green";
  }

  return ROULETTE_RED_NUMBERS.has(value) ? "red" : "black";
}

export function formatPogs(value) {
  const amount = Number(value || 0);
  return Number.isFinite(amount) ? amount.toLocaleString("en-GB") : "0";
}
